import Script from 'next/script';
import { FC } from 'react';

interface KlaviyoScriptProps {
	company_id?: string;
}

const KlaviyoScript: FC<KlaviyoScriptProps> = ({ company_id }) => !company_id ? null : (
	<Script
		id="klaviyo-script"
		async
		strategy="afterInteractive"
		src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${company_id}`}
	/>
)

export default KlaviyoScript;
